import bid1 from '../assets/images/explore/bid1.png';
import bid2 from '../assets/images/explore/bid2.png';
import bid3 from '../assets/images/explore/bid3.png';

export interface overviewRecentActivityDataType {
    id: number,
    logo: string,
    eventText: string,
    time: string,
}


//'2022-05-05 10:07:21'
export const overviewRecentActivityData: overviewRecentActivityDataType[] = [
    {
        id: 1,
        logo: bid1,
        eventText: 'Liked  by Nft bank',
        time: '2022-06-26 23:08:08',
    },
    {
        id: 2,
        logo: bid2,
        eventText: 'Liked  by Jatinder Parmar',
        time: '2022-06-25 23:08:08',
    },
    {
        id: 3,
        logo: bid3,
        eventText: 'Liked  by Geasnder Gemar',
        time: '2022-06-24 23:08:08',
    },
    {
        id: 4,
        logo: bid1,
        eventText: 'Liked  by Nft bank',
        time: '2022-06-23 23:08:08',
    },
    {
        id: 5,
        logo: bid2,
        eventText: 'Liked  by Jatinder Parmar',
        time: '2022-06-22 23:08:08',
    },
    {
        id: 6,
        logo: bid3,
        eventText: 'Liked  by Jatinder Parmar',
        time: '2022-06-21 23:08:08',
    },


]